<div class="p-fluid p-formgrid p-grid">
  <div class="p-col-12 p-sm-12  p-md-12 p-lg-3">
    <p-card header="Filtros" (keyup)="onEnterPesquisar($event)">
      <div class="p-grid">
        <m-restricao-number label="Id" [restricao]="restricoes.atributo('id')"></m-restricao-number>
        <m-restricao-string label="Nome da pessoa" [restricao]="restricoes.atributo('pessoa.nome')"></m-restricao-string>
        <m-restricao-string label="Nome do usuário" [restricao]="restricoes.atributo('usuario.nome')"></m-restricao-string>
        <m-restricao-temporal label="Data do acesso" [restricao]="restricoes.atributo('dataAcesso')"></m-restricao-temporal>
        <m-restricao-entidade label="Componente"
          [restricao]="restricoes.atributo('componente')"
          [itens]="componentesAuditoriaPessoaItens"
          itemId="value"
          itemLabel="label">
        </m-restricao-entidade>
      </div>
      <p-footer>
        <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-6">
            <button pButton label="Pesquisar" (click)="pesquisar()"></button>
          </div>
          <div class="p-col-12 p-md-6">
            <button pButton class="p-button-secondary" label="Limpar" (click)="limpar()"></button>
          </div>
        </div>
      </p-footer>
    </p-card>
  </div>

  <div class="p-col-12 p-md-9">
    <p-card>
      <div class="p-card-title">
        Lista de auditoria de acesso a pessoa
        <span *ngIf="carregandoPessoasAuditoria">
          <em class="pi-fw pi pi-spin pi-spinner"></em>
        </span>
        <span *ngIf="error" style="color: red">
          <em class="pi pi-times" pTooltip="Erro ao carregar os dados da pesquisa!"></em>
        </span>
      </div>

      <div *ngIf="pessoasAuditoria === undefined || pessoasAuditoria?.length === 0"  style="display: flex; justify-content: center; align-items: center; height: 700px;">
        <p *ngIf="pessoasAuditoria === undefined">
          Por favor realize uma pesquisa
        </p>

        <p *ngIf="pessoasAuditoria?.length === 0">
          Nenhum resultado foi encontrado
        </p>
      </div>

      <div *ngIf="pessoasAuditoria !== undefined" [hidden]="pessoasAuditoria?.length === 0">
        <p-virtualScroller
          #vsPessoasAuditoria class="lista-pessoas-auditoria"
          [value]="pessoasAuditoria"
          scrollHeight="700px"
          [itemSize]="117"
          [rows]="quantidadeRegistros"
          [lazy]="true"
          (onLazyLoad)="onLazyLoad($event.first)">
          <ng-template let-entidade pTemplate="item">
            <div class="lista-pessoas-auditoria__item border p-border-top">
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-6">
                  <ul class="list-group">
                    <li class="list-title-color">
                      <a class="lista-pessoas-auditoria__nome highlight list-title-color" [routerLink]="['/pessoa/visualizar', entidade.pessoa.id]">{{ entidade.id }} - {{ entidade.pessoa.nome }}</a>
                    </li>
                    <li>Usuário: {{ entidade.usuario.nome }}</li>
                  </ul>
                </div>

                <div class="p-field p-col-6">
                  <ul class="list-group">
                    <li>Data de acesso: {{ entidade.dataAcesso | date : 'short' : '' : 'pt-BR' }}</li>
                    <li *ngIf="entidade.componente === 'GRAPHQL'">Componente:
                      <span style="cursor: pointer; text-decoration: underline; color: #084298;" (click)="mostrarGraphQL(entidade.graphql)">{{ entidade.componente | dominio:'getPessoaAuditoriaAcessoComponenteItens' }}</span>
                    </li>
                    <li *ngIf="entidade.componente !== 'GRAPHQL'">Componente: {{ entidade.componente | dominio:'getPessoaAuditoriaAcessoComponenteItens' }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template let-car pTemplate="loadingItem">
            <div class="lista-pessoas-auditoria__carregando border p-border-top">
              <em class="pi-fw pi pi-spin pi-spinner"></em>
            </div>
          </ng-template>
        </p-virtualScroller>
      </div>
    </p-card>
  </div>
</div>

<p-dialog
  header="GraphQL"
  [showHeader]="true"
  [visible]="graphql"
  [modal]="true"
  [draggable]="false"
  [closable]="false"
  [style]="{ width: '80%', maxWidth: '700px' }"
  appendTo="body">
  <div style="width: 100%;">
    <div style="width: 100%; margin-top: 4px;">
      <pre *ngIf="graphql" class="json-color" style="max-height: 500px; overflow-y: scroll; margin: 0; padding: 8px 0; background-color: #f9f9f9;"> {{ parseJson(graphql) | json }}</pre>
    </div>
    <div style="text-align: center;">
      <button (click)="fecharGraphQL()" pButton type="button" label="Fechar" class="p-button-danger" style="margin-top: 1em;"></button>
    </div>
  </div>
</p-dialog>
